<script setup>
import { ref, watch, onMounted } from 'vue';
import axios from 'axios';

const props = defineProps({
    productId: Number,
});

const chartOptions = ref({
    chart: {
        height: '200px',
        type: 'line',
        zoom: { enabled: true },
        dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.5
        }
    },
    dataLabels: { 
        enabled: true,
        formatter: (value) => {
            return new Intl.NumberFormat('da-DK', {
                style: 'currency',
                currency: 'DKK',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        }
    },
    stroke: { curve: 'stepline' }, // Important: Makes the line a "step line"
    title: {
        text: 'Prishistorik',
        align: 'left'
    },
    xaxis: {
        type: 'datetime',
        categories: [],
        title: { text: 'Dato' },
        labels: {
            formatter: function (value) {
                return new Intl.DateTimeFormat('da-DK', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }).format(new Date(value));
            }
        }
    },
    yaxis: {
        title: { text: 'Pris' },
        labels: {
            formatter: function (val) {
                return new Intl.NumberFormat('da-DK', {
                    style: 'currency',
                    currency: 'DKK',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(val);
            }
        }
    },
    annotations: {
        xaxis: [
        { 
            x: 'Feb', 
            x2: 'Mar',
            borderColor: '#775DD0', 
            label: { 
            style: { color: '#fff', background: '#775DD0' }, 
            text: 'Feber Week' 
            } 
        }
        ]
    }
});

const series = ref([
    {
        name: 'Pris',
        data: []
    }
]);

onMounted(() => {
    axios.get(`/product/${props.productId}/price-graph-data`).then(response => {
        const formattedSeries = response.data.categories.map((date, i) => ({
                x: date, // string in ISO format, e.g. "2025-04-10"
                y: parseFloat(response.data.prices[i]) // convert "2579.00" to 2579
            }));

        series.value[0].data = formattedSeries;

    }).catch(error => {
        console.error('Error fetching price graph data:', error);
    });
});
</script>

<template>
    <div class="price-graph-container">
        <apexchart 
            type="line" 
            :options="chartOptions" 
            :series="series" 
            width="100%" 
            height="300px">
        </apexchart>
    </div>
</template>

<style scoped>
.price-graph-container {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background-color: #f8f9fa;
    padding: 1rem;
    margin-top: 1rem;
}

.price-graph-container .apexcharts-canvas {
    max-height: 100%;
}
</style>